export const FULFILLMENT_TIME_STORAGE_KEY = "client_fulfillmentTime";
export class FulfillmentTimeStorageManager {
    store(fulfillmentTime) {
        const fulfillmentTimeDataString = JSON.stringify(fulfillmentTime);
        localStorage.setItem(FULFILLMENT_TIME_STORAGE_KEY, fulfillmentTimeDataString);
    }
    restore() {
        const fulfillmentTimeDataString = localStorage.getItem(FULFILLMENT_TIME_STORAGE_KEY);
        if (fulfillmentTimeDataString === null) {
            return null;
        }
        return JSON.parse(fulfillmentTimeDataString);
    }
    erase() {
        localStorage.removeItem(FULFILLMENT_TIME_STORAGE_KEY);
    }
}
